"use strict";

var _regeneratorRuntime = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/createClass.js");

var _assertThisInitialized = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var types_1 = require("./types");

var context_1 = require("./context");

var initLDClient_1 = __importDefault(require("./initLDClient"));

var utils_1 = require("./utils");

var getFlagsProxy_1 = __importDefault(require("./getFlagsProxy"));
/**
 * The `LDProvider` is a component which accepts a config object which is used to
 * initialize `launchdarkly-js-client-sdk`.
 *
 * This Provider does three things:
 * - It initializes the ldClient instance by calling `launchdarkly-js-client-sdk` initialize on `componentDidMount`
 * - It saves all flags and the ldClient instance in the context API
 * - It subscribes to flag changes and propagate them through the context API
 *
 * Because the `launchdarkly-js-client-sdk` in only initialized on `componentDidMount`, your flags and the
 * ldClient are only available after your app has mounted. This can result in a flicker due to flag changes at
 * startup time.
 *
 * This component can be used as a standalone provider. However, be mindful to only include the component once
 * within your application. This provider is used inside the `withLDProviderHOC` and can be used instead to initialize
 * the `launchdarkly-js-client-sdk`. For async initialization, check out the `asyncWithLDProvider` function
 */


var LDProvider = /*#__PURE__*/function (_react_1$Component) {
  _inherits(LDProvider, _react_1$Component);

  var _super = _createSuper(LDProvider);

  function LDProvider(props) {
    var _this;

    _classCallCheck(this, LDProvider);

    _this = _super.call(this, props);

    _this.getReactOptions = function () {
      return Object.assign(Object.assign({}, types_1.defaultReactOptions), _this.props.reactOptions);
    };

    _this.subscribeToChanges = function (ldClient) {
      var targetFlags = _this.props.flags;
      ldClient.on('change', function (changes) {
        var reactOptions = _this.getReactOptions();

        var updates = (0, utils_1.getFlattenedFlagsFromChangeset)(changes, targetFlags);
        var unproxiedFlags = Object.assign(Object.assign({}, _this.state.unproxiedFlags), updates);

        if (Object.keys(updates).length > 0) {
          _this.setState(Object.assign({
            unproxiedFlags: unproxiedFlags
          }, (0, getFlagsProxy_1.default)(ldClient, unproxiedFlags, reactOptions, targetFlags)));
        }
      });
    };

    _this.initLDClient = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, clientSideID, flags, options, user, ldClient, reactOptions, unproxiedFlags, error, initialisedOutput;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, clientSideID = _this$props.clientSideID, flags = _this$props.flags, options = _this$props.options, user = _this$props.user;
                _context.next = 3;
                return this.props.ldClient;

              case 3:
                ldClient = _context.sent;
                reactOptions = this.getReactOptions();

                if (!ldClient) {
                  _context.next = 9;
                  break;
                }

                unproxiedFlags = (0, utils_1.fetchFlags)(ldClient, flags);
                _context.next = 15;
                break;

              case 9:
                _context.next = 11;
                return (0, initLDClient_1.default)(clientSideID, user, options, flags);

              case 11:
                initialisedOutput = _context.sent;
                unproxiedFlags = initialisedOutput.flags;
                ldClient = initialisedOutput.ldClient;
                error = initialisedOutput.error;

              case 15:
                this.setState(Object.assign(Object.assign({
                  unproxiedFlags: unproxiedFlags
                }, (0, getFlagsProxy_1.default)(ldClient, unproxiedFlags, reactOptions, flags)), {
                  ldClient: ldClient,
                  error: error
                }));
                this.subscribeToChanges(ldClient);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    var options = props.options;
    _this.state = {
      flags: {},
      unproxiedFlags: {},
      flagKeyMap: {},
      ldClient: undefined
    };

    if (options) {
      var bootstrap = options.bootstrap;

      if (bootstrap && bootstrap !== 'localStorage') {
        var _this$getReactOptions = _this.getReactOptions(),
            useCamelCaseFlagKeys = _this$getReactOptions.useCamelCaseFlagKeys;

        _this.state = {
          flags: useCamelCaseFlagKeys ? (0, utils_1.camelCaseKeys)(bootstrap) : bootstrap,
          unproxiedFlags: bootstrap,
          flagKeyMap: {},
          ldClient: undefined
        };
      }
    }

    return _this;
  }

  _createClass(LDProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$props2, user, deferInitialization;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, user = _this$props2.user, deferInitialization = _this$props2.deferInitialization;

                if (!(deferInitialization && !user)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return this.initLDClient();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$props3, user, deferInitialization, userJustLoaded;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, user = _this$props3.user, deferInitialization = _this$props3.deferInitialization;
                userJustLoaded = !prevProps.user && user;

                if (!(deferInitialization && userJustLoaded)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.initLDClient();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          flags = _this$state.flags,
          flagKeyMap = _this$state.flagKeyMap,
          ldClient = _this$state.ldClient,
          error = _this$state.error;
      return react_1.default.createElement(context_1.Provider, {
        value: {
          flags: flags,
          flagKeyMap: flagKeyMap,
          ldClient: ldClient,
          error: error
        }
      }, this.props.children);
    }
  }]);

  return LDProvider;
}(react_1.Component);

exports.default = LDProvider;